<mat-button-toggle
  (click)="openHelpModal()"
  class="toolbar-button without-checked-state"
  [matTooltip]="tooltip"
  h3TrackAs
  eventId="show_help_popup"
  subBucket="frame"
>
  <mat-icon [h3CustomIcon]="keyboardShortcutsIcon"></mat-icon>
</mat-button-toggle>
